import React from "react";
import clsx from "clsx";

import { MenuItemLink } from "react-admin";
import { Grid, MenuList, Paper, Divider } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import { ForceTitle } from "../../components/common/ForceTitle";
import {
  BarChartIcon,
  PieChartIcon,
  TableChartIcon,
  TimelineIcon,
} from "../../components/common/iconography";
import MonthlyInboundsChart from "./shipment/MonthlyInboundsChart";
import MonthlyOutboundsChart from "./shipment/MonthlyOutboundsChart";
import { MonthlyRevenueChart } from "./financial/MonthlyRevenueChart";
import Title from "./Title";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    padding: theme.spacing(2),
  },
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
    minHeight: "100%",
    boxShadow: theme.shadows[2],
  },
  fixedHeight: {
    height: 240,
  },
  doubleFixedHeight: {
    height: 360,
  },
}));

const Reports = (props) => {
  const classes = useStyles();
  const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);

  return (
    <div className={classes.root}>
      <div style={{ display: "none" }}>
        <ForceTitle title="Reports" />
      </div>

      {/* KPI Charts */}
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Paper className={fixedHeightPaper}>
            <MonthlyInboundsChart />
          </Paper>
        </Grid>
        <Grid item xs={12} md={6}>
          <Paper className={fixedHeightPaper}>
            <MonthlyOutboundsChart />
          </Paper>
        </Grid>
        <Grid item xs={12}>
          <Paper className={clsx(classes.paper, classes.doubleFixedHeight)}>
            <MonthlyRevenueChart />
          </Paper>
        </Grid>
      </Grid>

      <Grid container spacing={2} style={{ marginTop: 16 }}>
        {/* Inventory Reports */}
        <Grid item xs={12} md={6}>
          <Paper className={classes.paper}>
            <Title>📦 Inventory Reports</Title>
            <Divider style={{ marginBottom: 8 }} />
            <MenuList>
              <MenuItemLink
                to="/reportInventoryByLoadType"
                primaryText="Inventory By Load Type"
                leftIcon={<PieChartIcon />}
                dense
              />
              <MenuItemLink
                to="/reportTurnoverByMonth"
                primaryText="Avg. Inventory Turnover by Month"
                leftIcon={<BarChartIcon />}
                dense
              />
              <MenuItemLink
                to="/reportTurnoverByAccount"
                primaryText="Avg. Inventory Turnover by Account"
                leftIcon={<BarChartIcon />}
                dense
              />
              <MenuItemLink
                to="/reportInventoryActivity"
                primaryText="Inventory Activity Report"
                leftIcon={<TimelineIcon />}
                dense
              />
              <MenuItemLink
                to="/reportInventorySnapshot"
                primaryText="Inventory Snapshot Report"
                leftIcon={<TableChartIcon />}
                dense
              />
              <MenuItemLink
                to="/reportProductActivity"
                primaryText="Product Activity Report"
                leftIcon={<TableChartIcon />}
                dense
              />
              <MenuItemLink
                to="/reports/product-velocity"
                primaryText="Product Velocity Report"
                leftIcon={<TableChartIcon />}
                dense
              />
              <MenuItemLink
                to="/reportLowInventory"
                primaryText="Low Inventory Report"
                leftIcon={<TableChartIcon />}
                dense
              />
              <MenuItemLink
                to="/reportInventoryRecall"
                primaryText="Inventory Recall Report"
                leftIcon={<TableChartIcon />}
                dense
              />
            </MenuList>
          </Paper>
        </Grid>

        {/* Shipment Reports */}
        <Grid item xs={12} md={6}>
          <Paper className={classes.paper}>
            <Title>🚚 Shipment Reports</Title>
            <Divider style={{ marginBottom: 8 }} />
            <MenuList>
              <MenuItemLink
                to="/reportCarsByAccount"
                primaryText="Avg. Inbounds by Account"
                leftIcon={<BarChartIcon />}
                dense
              />
              <MenuItemLink
                to="/reportTotalInOut"
                primaryText="Total In/Out Loads"
                leftIcon={<TableChartIcon />}
                dense
              />
              <MenuItemLink
                to="/reportRailcarsProcessed"
                primaryText="Railcars Processed"
                leftIcon={<TableChartIcon />}
                dense
              />
              <MenuItemLink
                to="/reportInboundDemurrage"
                primaryText="Inbound Demurrage Report"
                leftIcon={<TableChartIcon />}
                dense
              />
              <MenuItemLink
                to="/reportOutboundDemurrage"
                primaryText="Outbound Demurrage Report"
                leftIcon={<TableChartIcon />}
                dense
              />
              <MenuItemLink
                to="/reportOpenOrders"
                primaryText="Open Orders Report"
                leftIcon={<TableChartIcon />}
                dense
              />
            </MenuList>
          </Paper>
        </Grid>

        {/* Financial Reports */}
        <Grid item xs={12} md={6}>
          <Paper className={classes.paper}>
            <Title>💵 Financial Reports</Title>
            <Divider style={{ marginBottom: 8 }} />
            <MenuList>
              <MenuItemLink
                to="/reportInvoiceAudit"
                primaryText="Invoicing Audit Report"
                leftIcon={<TableChartIcon />}
                dense
              />
              <MenuItemLink
                to="/reportBillingDetails"
                primaryText="Billing Details Report"
                leftIcon={<TableChartIcon />}
                dense
              />
              <MenuItemLink
                to="/reportInventoryStorage"
                primaryText="Storage Billing Report"
                leftIcon={<TableChartIcon />}
                dense
              />
            </MenuList>
          </Paper>
        </Grid>
      </Grid>
    </div>
  );
};

export default Reports;
